module.exports = __webpack_public_path__ + "2376f061a49ba8a14e48e0ddd5cd72a4.svg";